import Laptop from './Laptop';

export default Laptop;
